import React, { Component } from 'react';
import styled from 'styled-components';
import AccountNavigation from './AccountNavigation';
import Colors from '../../../../constants/colors';
//grid-template-rows: 480px;
const SideNavContainer = styled.div`
  display: grid;
  grid-template-rows: auto;
  border-right: 1px solid ${Colors.SEPARATOR_GRAY};
  padding: 20px;
`;

const SideNavBody = styled.div`

`;

const SideNavFooter = styled.div`

`;

class AccountSideNav extends Component {
  render() {
    const { handleReset, handlePopulate, history, location } = this.props;

    return (
      <SideNavContainer>
        <SideNavBody>
          <AccountNavigation
            handleReset={handleReset}
            handlePopulate={handlePopulate}
            history={history}
            location={location}
          />
        </SideNavBody>
      </SideNavContainer>
    );
  }
}

export default AccountSideNav;